var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "mb-4 mx-2",
    attrs: {
      "flat": "",
      "outlined": ""
    }
  }, [_c('v-form', {
    model: {
      value: _vm.localValid,
      callback: function callback($$v) {
        _vm.localValid = $$v;
      },
      expression: "localValid"
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("common.nouns.details")) + " "), _c('v-spacer'), !_vm.isEditing ? _c('m-icon-button', {
    on: {
      "click": function click($event) {
        _vm.isEditing = true;
      }
    }
  }) : [_c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "elevation": "0",
      "disabled": !_vm.localValid || _vm.loading,
      "loading": _vm.loading
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("save")) + " ")]), _c('v-btn', {
    attrs: {
      "outlined": "",
      "elevation": "0"
    },
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")])]], 2), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.title'),
      "readonly": !_vm.isEditing,
      "outlined": ""
    },
    on: {
      "input": function input($event) {
        return _vm.onChanged('objects.contract.title');
      }
    },
    model: {
      value: _vm.local.title,
      callback: function callback($$v) {
        _vm.$set(_vm.local, "title", $$v);
      },
      expression: "local.title"
    }
  }), _c('template-editor', {
    key: 'template-editor' + !_vm.isEditing,
    staticClass: "mb-8",
    attrs: {
      "outlined": true,
      "label": _vm.$t('objects.contract.description'),
      "readOnly": !_vm.isEditing
    },
    on: {
      "input": function input($event) {
        return _vm.onChanged('objects.contract.description');
      }
    },
    model: {
      value: _vm.local.description,
      callback: function callback($$v) {
        _vm.$set(_vm.local, "description", $$v);
      },
      expression: "local.description"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.startDate'),
      "type": "date",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing
    },
    on: {
      "input": function input($event) {
        return _vm.onChanged('objects.contract.startDate');
      }
    },
    model: {
      value: _vm.local.startDateFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.local, "startDateFormable", $$v);
      },
      expression: "local.startDateFormable"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.endDate'),
      "type": "date",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing
    },
    on: {
      "input": function input($event) {
        return _vm.onChanged('objects.contract.endDate');
      }
    },
    model: {
      value: _vm.local.endDateFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.local, "endDateFormable", $$v);
      },
      expression: "local.endDateFormable"
    }
  }), _c('refs-select-form', {
    attrs: {
      "label": _vm.$t('objects.contract.clientIds'),
      "partnerId": _vm.local.partnerId,
      "disabled": !_vm.isEditing,
      "categories": [_vm.ResourceEnum.COMPANY, _vm.ResourceEnum.PERSON],
      "small": true
    },
    on: {
      "input": function input($event) {
        return _vm.onChanged('objects.contract.clientIds');
      }
    },
    model: {
      value: _vm.local.clientIds,
      callback: function callback($$v) {
        _vm.$set(_vm.local, "clientIds", $$v);
      },
      expression: "local.clientIds"
    }
  }), _c('refs-select-form', {
    attrs: {
      "label": _vm.$t('objects.contract.providerIds'),
      "partnerId": _vm.local.partnerId,
      "disabled": !_vm.isEditing,
      "categories": [_vm.ResourceEnum.COMPANY, _vm.ResourceEnum.PERSON],
      "small": true
    },
    on: {
      "input": function input($event) {
        return _vm.onChanged('objects.contract.providerIds');
      }
    },
    model: {
      value: _vm.local.providerIds,
      callback: function callback($$v) {
        _vm.$set(_vm.local, "providerIds", $$v);
      },
      expression: "local.providerIds"
    }
  }), _vm.local.type === _vm.contracTypeEnum.INSURANCE && _vm.local.details ? _c('insurance-contract-form', {
    attrs: {
      "isEditing": _vm.isEditing
    },
    on: {
      "update:details": _vm.updateDetails,
      "field-changed": _vm.onChildFormChanged
    },
    model: {
      value: _vm.local.details,
      callback: function callback($$v) {
        _vm.$set(_vm.local, "details", $$v);
      },
      expression: "local.details"
    }
  }) : _vm.local.type === _vm.contracTypeEnum.WORKSHOP && _vm.local.details ? _c('workshop-contract-form', {
    attrs: {
      "isEditing": _vm.isEditing
    },
    on: {
      "update:details": _vm.updateDetails,
      "field-changed": _vm.onChildFormChanged
    },
    model: {
      value: _vm.local.details,
      callback: function callback($$v) {
        _vm.$set(_vm.local, "details", $$v);
      },
      expression: "local.details"
    }
  }) : _vm.local.type === _vm.contracTypeEnum.CUSTOMER && _vm.local.details ? _c('customer-contract-form', {
    attrs: {
      "isEditing": _vm.isEditing
    },
    on: {
      "update:details": _vm.updateDetails,
      "field-changed": _vm.onChildFormChanged
    },
    model: {
      value: _vm.local.details,
      callback: function callback($$v) {
        _vm.$set(_vm.local, "details", $$v);
      },
      expression: "local.details"
    }
  }) : _vm._e()], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }